import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGamColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3859 12.415L12.4149 21.386C11.5965 22.2044 10.269 22.2044 9.45056 21.386C8.63127 20.5676 8.63216 19.2401 9.45056 18.4217L18.4225 9.44974C19.2409 8.63134 20.5684 8.63134 21.3868 9.44974C22.2052 10.269 22.2052 11.5957 21.3859 12.415Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4144 21.3868C13.2332 20.5681 13.2332 19.2405 12.4144 18.4218C11.5956 17.603 10.2681 17.603 9.44934 18.4218C8.63055 19.2405 8.63055 20.5681 9.44934 21.3868C10.2681 22.2056 11.5956 22.2056 12.4144 21.3868Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.004 5.03244L9.51758 9.51796L12.4819 12.4823L16.9683 7.99679C17.7867 7.17839 17.7867 5.85084 16.9683 5.03244C16.149 4.21314 14.8224 4.21314 14.004 5.03244Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.9966 16.9684L12.4821 12.4829L9.51777 9.51855L5.03226 14.0041C4.21386 14.8225 4.21386 16.15 5.03226 16.9684C5.85066 17.7868 7.1782 17.7868 7.9966 16.9684Z",
			fill: "#3B80EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4925 12.4728C13.3113 11.654 13.3113 10.3265 12.4925 9.5077C11.6738 8.68891 10.3462 8.68891 9.52746 9.5077C8.70868 10.3265 8.70868 11.654 9.52746 12.4728C10.3462 13.2916 11.6738 13.2916 12.4925 12.4728Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5501 3.57815L3.57815 12.5501C2.75975 13.3685 1.4322 13.3685 0.613801 12.5501C-0.2046 11.7317 -0.2046 10.4041 0.613801 9.58573L9.58573 0.613801C10.4041 -0.2046 11.7317 -0.2046 12.5501 0.613801C13.3685 1.4322 13.3685 2.75975 12.5501 3.57815Z",
			fill: "#3B80EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0674 4.19329C12.2253 4.19329 13.164 3.25459 13.164 2.09665C13.164 0.938701 12.2253 0 11.0674 0C9.9094 0 8.9707 0.938701 8.9707 2.09665C8.9707 3.25459 9.9094 4.19329 11.0674 4.19329Z",
			fill: "#34A853"
		})
	]
});
export default SvgGamColor;
